import React, { useState } from "react";

const PlayerImg = (props) => {
    const { p_no, p_img } = props;
    const [srcIndex, setSrcIndex] = useState(0);

    // 연도와 이미지명 추출
    const year = p_img.split("_")[0];
    const imgName = p_img.split("_").slice(1).join("_");

    // 로컬 이미지 (정적 require)
    const localImage = (() => {
        try {
            return require(`../../../assets/images/player/${imgName}.jpg`);
        } catch (e) {
            return "";
        }
    })();

    // 소스 순서대로 시도
    const sources = [
        `https://6ptotvmi5753.edge.naverncp.com/KBO_IMAGE/person/middle/${year}/${p_no}.jpg`,
        `${process.env.PUBLIC_URL}/assets/images/player/kbo/${p_no}.jpg`,
        localImage,
    ];

    const handleError = () => {
        setSrcIndex((prev) => (prev < sources.length - 1 ? prev + 1 : prev));
    };

    return (
        <img
            src={sources[srcIndex]}
            alt=""
            onError={handleError}
            className="w-full md:h-full md:w-auto bg-white"
        />
    );
};

export default PlayerImg;
